import { ClassroomAttendanceService } from "./../../classroomAttendance.service";
import { AddPointService } from "./addPoints.service";
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

import { Subscription } from "rxjs";
import { Router } from "@angular/router";

@Component({
	selector: "caass-classroom-classroomAttendance-Point-AddPoints",
	templateUrl: "./AddPoints.component.html",
	providers: [AddPointService],
})
export class ClassroomAttendancePointAddPointsComponent {
	@Input() personid: any;
	@Input() schoolID: any;
	@Input() balancePoint: any;
	@Input() selectecStudentList: any;
	@Output() onPointChange: EventEmitter<any> = new EventEmitter<any>();
	classroomOnly: 1;
	pointsItemList: any = [];
	SelectedPointsItemID = 0;

	erroMessage = "";

	points: any = [];
	constructor(private classroomService: ClassroomAttendanceService, private addPointService: AddPointService) {}
	ngOnInit() {
		if (this.selectecStudentList && this.selectecStudentList.length > 0) {
			this.schoolID = this.selectecStudentList[0].SchoolID;

			var pointtransactions = this.points;

			$.each(this.selectecStudentList, function (index, result) {
				pointtransactions.push({
					PersonID: result.PersonID,
					SchoolID: result.SchoolID,
				});
			});
		} else {
			this.points.push({
				SchoolID: this.schoolID,
				PersonID: this.personid,
			});
		}

		this.PointsItemGetList();
	}
	cancelClick() {
		this.classroomService.cancelEdit();
	}
	public changePoint(Point: any): void {
		Point = this.balancePoint;
		// alert("changepointcaleed");
		this.onPointChange.emit(Point);
	}

	private PointsItemGetList() {
		//alert("addpoint hit");

		var result = this.addPointService.PointsItemGetList(1, this.schoolID); //CategoryID = 1 is add points

		result.subscribe(
			(response: any) => {
				this.pointsItemList = response;

				if (this.pointsItemList.length > 1) {
					this.pointsItemList.unshift({
						PointsItemID: 0,
						PointsItemDesc: "Choose Point to be awarded",
						PointsItemValue: "",
					});
				}
			},
			(error) => {}
		);
	}

	onPointsItemChange(newPointsItemID) {
		this.erroMessage = "";
		const result = this.pointsItemList.filter((index) => index.PointsItemID == newPointsItemID);

		//this.points.PointsItemValue = result[0].PointsItemValue;
		var PointsItemValue = result[0].PointsItemValue;
		//this.points.PointsTransactionTypeID = 1;

		$.each(this.points, function (index, result) {
			result.PointsItemID = newPointsItemID;
			result.PointsItemValue = PointsItemValue;
			result.PointsTransactionTypeID = 1;
		});
	}

	saving = false;
	submitClick() {
		if (!this.SelectedPointsItemID) {
			this.erroMessage = "Select the point";
			return;
		}

		this.saving = true;
		var result = this.addPointService.TransactionInsert(this.points);

		result.subscribe(
			(response: any) => {
				this.classroomService.LoadData();
			},
			(error) => {
				this.erroMessage = "Error Occured";
				this.saving = false;
			}
		);
	}
}
